import { useState } from 'react';

import ComponentKitTabs from 'components/ui/KitComponents/Tab';
import CasinoTournament from 'components/CasinoComponents/Battles/CasinoTournament';
import ProviderTournaments from 'components/CasinoComponents/Battles/CasinoProviderTournaments';

import { TournamentTabs } from './types';

import styles from './Tournament.module.css';

const ModalCasinoTournament = () => {
  const [activeTab, setActiveTab] = useState<TournamentTabs>(
    TournamentTabs.ActiveTournament
  );

  return (
    <div>
      <ComponentKitTabs
        activeValue={activeTab}
        data={[
          {
            label: 'tournaments.tabs.activeTournament',
            value: TournamentTabs.ActiveTournament,
          },
          {
            label: 'tournaments.tabs.providerTournaments',
            value: TournamentTabs.ProviderTournaments,
          },
        ]}
        onChange={setActiveTab}
        classes={styles.tabs}
      />

      {activeTab === TournamentTabs.ActiveTournament ? (
        <CasinoTournament />
      ) : (
        <ProviderTournaments onlyActive />
      )}
    </div>
  );
};

export default ModalCasinoTournament;
